<template>
    <div class="container">
        <div class="row">
            <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
                <div class="account-box text-center">
                    <router-link to="/" class="logo">
                        <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                    </router-link>
                    <div class="account-box-title text-center">به {{baseInfo.ShopName}} خوش آمدید</div>
                    <div class="account-box-content">
                        <div class="account-box-message">
                            <i class="account-box-message-icon now-ui-icons users_single-02"></i>
                            <h3>حساب کاربری شما در {{baseInfo.ShopName}} ساخته شد</h3>
                            <p>
                                ثبت نام شما با موفقیت انجام شد.
                                پس از تایید مدیریت، امکان استعلام قیمت و سفارش برای شما فعال خواهد شد.
                                تایید مدیریت، از طریق پیامک به شما اطلاع رسانی خواهد شد.
                            </p>
                            <ul class="account-box-message-links">
                                <li>
                                    <div class="parent-btn">
                                        <router-link to="/" class="dk-btn dk-btn-info">
                                            بازگشت به صفحه‌ای اصلی
                                            <i class="now-ui-icons users_single-02"></i>
                                        </router-link>
                                    </div>
                                </li>
                                <!--<li><router-link tag="a" to="/" class="btn-link-border">بازگشت به صفحه‌ای اصلی</router-link></li>-->
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeMount: function () {
            createPageTitle('خوش آمدید');
        },
    }
</script>

<style scoped>
</style>